export const TITLE_NOTE = 'Note'
export const TITLE_NOTES = 'Notes'
export const TITLE_NOTE_ADD = 'Add a note'
